import React from 'react';

type IconProps = {
    color?: string;
    width?: number;
    height?: number;
};

const IconFullLeftArrow: React.FC<IconProps> = ({ color = 'black', width = 17, height = 17 }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 17 17"
            fill="none"
        >
            <g clip-path="url(#clip0_10276_15975)">
                <path
                    d="M16.8052 8.02994C16.805 8.02974 16.8049 8.02951 16.8046 8.02931L13.3348 4.57619C13.0748 4.3175 12.6544 4.31846 12.3956 4.57844C12.1369 4.83839 12.1379 5.25884 12.3978 5.51756L14.7275 7.83594H0.664062C0.297301 7.83594 0 8.13324 0 8.5C0 8.86676 0.297301 9.16406 0.664062 9.16406H14.7275L12.3979 11.4824C12.1379 11.7412 12.1369 12.1616 12.3957 12.4216C12.6544 12.6816 13.0749 12.6825 13.3348 12.4238L16.8047 8.97069C16.8049 8.97049 16.805 8.97025 16.8053 8.97005C17.0653 8.71047 17.0645 8.28866 16.8052 8.02994Z"
                    fill="black"
                />
            </g>
            <defs>
                <clipPath id="clip0_10276_15975">
                    <rect width="17" height="17" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconFullLeftArrow;
